import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-[10000] overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_3 = { class: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blue-100" }
const _hoisted_4 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-4 bg-gray-50 rounded-lg p-4 text-left" }
const _hoisted_6 = { class: "grid grid-cols-1 gap-3 text-sm" }
const _hoisted_7 = { class: "flex justify-between items-center border-b pb-2" }
const _hoisted_8 = { class: "font-bold text-black" }
const _hoisted_9 = { class: "flex justify-between items-center border-b pb-2" }
const _hoisted_10 = { class: "font-semibold text-black" }
const _hoisted_11 = { class: "flex justify-between items-center border-b pb-2" }
const _hoisted_12 = { class: "font-semibold text-black" }
const _hoisted_13 = { class: "flex justify-between items-center" }
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = { class: "font-semibold text-black" }
const _hoisted_16 = { class: "text-xs text-black" }
const _hoisted_17 = { class: "mt-4" }
const _hoisted_18 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3" }
const _hoisted_19 = ["disabled"]

import { ref, watch } from 'vue'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { ChatBubbleLeftRightIcon } from '@heroicons/vue/24/outline'

interface OrderInfo {
  client: string
  seller: string
  author: string
  creationDate: string
}

interface Props {
  show: boolean
  orderId: number | null
  orderInfo?: OrderInfo
}

interface Emits {
  (e: 'submit', data: { comment: string }): void
  (e: 'cancel'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CommentModal',
  props: {
    show: { type: Boolean },
    orderId: {},
    orderInfo: {}
  },
  emits: ["submit", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const comment = ref('')

// Format date for display
const formatDisplayDate = (dateString: string | undefined) => {
  if (!dateString) return 'Date non spécifiée'
  
  try {
    const date = new Date(dateString)
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  } catch {
    return dateString
  }
}

// Reset the comment when modal opens/closes
watch(() => props.show, (newVal) => {
  if (!newVal) {
    comment.value = ''
  }
})

const handleSubmit = () => {
  if (comment.value.trim()) {
    emit('submit', { comment: comment.value.trim() })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _ctx.show
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-[10000]",
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity z-[9999]" }, null, -1)
            ])),
            _: 1,
            __: [3]
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 z-[10001]" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_unref(ChatBubbleLeftRightIcon), {
                            class: "h-6 w-6 text-blue-600",
                            "aria-hidden": "true"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_unref(DialogTitle), {
                            as: "h3",
                            class: "text-base font-semibold leading-6 text-black"
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode(" Ajouter un commentaire ")
                            ])),
                            _: 1,
                            __: [4]
                          }),
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, [
                                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "font-medium text-black" }, "Commande:", -1)),
                                _createElementVNode("span", _hoisted_8, "#" + _toDisplayString(_ctx.orderId), 1)
                              ]),
                              _createElementVNode("div", _hoisted_9, [
                                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "font-medium text-black" }, "Client:", -1)),
                                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.orderInfo?.client || 'Non spécifié'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_11, [
                                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "font-medium text-black" }, "Vendeur:", -1)),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.orderInfo?.seller || 'Non spécifié'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_13, [
                                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "font-medium text-black" }, "Création:", -1)),
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.orderInfo?.author || 'Non spécifié'), 1),
                                  _createElementVNode("div", _hoisted_16, _toDisplayString(formatDisplayDate(_ctx.orderInfo?.creationDate)), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _cache[9] || (_cache[9] = _createElementVNode("label", {
                              for: "comment",
                              class: "block text-sm font-medium leading-6 text-black text-left mb-2"
                            }, " Votre commentaire ", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              id: "comment",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((comment).value = $event)),
                              rows: "4",
                              class: "block w-full rounded-md border-0 py-2 text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-black focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6",
                              placeholder: "Saisissez votre commentaire ici..."
                            }, null, 512), [
                              [_vModelText, comment.value]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 sm:col-start-2 disabled:opacity-50 disabled:cursor-not-allowed",
                          disabled: !comment.value.trim(),
                          onClick: handleSubmit
                        }, " Ajouter le commentaire ", 8, _hoisted_19),
                        _createElementVNode("button", {
                          type: "button",
                          class: "mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-black shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
                        }, " Annuler ")
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})